/**
 * @module footnote/utils
 */

import DocumentFragment from "@ckeditor/ckeditor5-engine/src/view/documentfragment";
import Node from "@ckeditor/ckeditor5-engine/src/view/node";
import { DowncastWriter, Element } from 'ckeditor5/src/engine';

const FIELD = 'footnote';
const SYMBOL = Symbol( 'footnote' );

/**
 * Returns `true` if a given view node is the footnote element.
 *
 * @param {Node | DocumentFragment} node
 * @returns {Boolean}
 */
export function isFootnoteElement( node ) {
	return node.is( 'containerElement' ) && !!node.getCustomProperty( SYMBOL );
}

let counter = 0;

/**
 * Creates footnote {@link Element} with provided `value` attribute.
 *
 * @param {Element} modelElement
 * @param {DowncastWriter} viewWriter
 * @param {Boolean} [editing] Default false
 * @returns
 */
export function createFootnoteElement( modelElement, viewWriter, editing = false ) {
	const value = modelElement.getAttribute( 'value' );

	const viewElement = viewWriter.createContainerElement( 'span', {
		class: FIELD
	}, {
		isAllowedInsideAttributeElement: true
	} );

	let innerText = null;
	if ( editing ) {
		innerText = viewWriter.createText( `[*]` );
	} else {
		innerText = viewWriter.createText( value );
	}

	if ( innerText != null ) {
		viewWriter.insert( viewWriter.createPositionAt( viewElement, 0 ), innerText );
	}

	viewWriter.setCustomProperty( SYMBOL, true, viewElement );

	return viewElement;
}
